import { render, staticRenderFns } from "./KurccCategoriesPage.vue?vue&type=template&id=67906af0&"
import script from "./KurccCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./KurccCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports